"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _Export = _interopRequireDefault(require("@rsuite/icon-font/lib/network/Export"));

// Generated by script, don't edit it please.
var Export = (0, _createSvgIcon["default"])({
  as: _Export["default"],
  ariaLabel: 'export',
  category: 'network',
  displayName: 'Export'
});
var _default = Export;
exports["default"] = _default;
module.exports = exports.default;